import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

// Blogs that helped make this
// https://www.gatsbyjs.org/docs/working-with-images/
// https://codebushi.com/using-gatsby-image/
// https://medium.freecodecamp.org/how-i-made-my-portfolio-website-blazing-fast-with-gatsby-82ccddc2f671

export const fixedImage = graphql`
  fragment fixedImage on File {
    childImageSharp {
      fixed(width: 100, height: 65, quality: 100) {
        ...GatsbyImageSharpFixed
      }
    }
  }
`

export default function BlogThumbImage({ slug, alt, ...props }) {
  return (
    <StaticQuery
      query={graphql`
        query {
          defaultImage: file(relativePath: { eq: "default.png" }) {
            ...fixedImage
          }
          blogImages: allFile(filter: { relativePath: { regex: "/blog/.*/" } }) {
            edges {
              node {
                name
                ...fixedImage
              }
            }
          }
        }
      `}
      render={(innerProps) => {
        const foundImage = innerProps.blogImages.edges.find((edge) => edge.node.name === slug)

        const imageData = foundImage
          ? foundImage.node.childImageSharp.fixed
          : innerProps.defaultImage.childImageSharp.fixed

        return <Img fixed={imageData} alt={alt} {...props} />
      }}
    />
  )
}
